import { render } from "./EntregasComponent.vue?vue&type=template&id=207cb53e&scoped=true"
import script from "./EntregasComponent.vue?vue&type=script&lang=js"
export * from "./EntregasComponent.vue?vue&type=script&lang=js"

import "./EntregasComponent.vue?vue&type=style&index=0&id=207cb53e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207cb53e"]])

export default __exports__